import React, { useEffect } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProjectsPage from "./pages/projekte/ProjectsPage";
import PersonenPage from "./pages/projekte/personen/PersonenPage";
import MixAnsichtPage from "./pages/projekte/mix-ansicht/MixAnsichtPage";
import LageplanPage from "./pages/projekte/lageplan/LageplanPage";
import ProjectDetailPage from "./pages/projekte/ProjectDetailPage";
import "bootstrap/dist/css/bootstrap.min.css";
import "./main.css";
import { goToLocationReplace, useLocation } from "./utils/router";
import { processResponse } from "./utils/auth";
import RenderPage from "./cms/RenderPage";
import { SiteMap } from "./cms/SiteMap";

export default function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [location]);

  // check if old url is used: /projects* -> /projekte*
  if (location.startsWith("/projects")) {
    setTimeout(
      () => goToLocationReplace(location.replace("/projects", "/projekte")),
      1
    );
    return <div>Redirecting...</div>;
  }

  const projectDetail = ProjectRoutes(location);
  if (projectDetail) {
    return (
      <>
        <Navbar />
        {projectDetail}
        <Footer />
      </>
    );
  }

  // Static routes
  const Route = Routes[location];
  if (Route) {
    return (
      <>
        <Navbar />
        <Route />
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <RenderPage path={location} />
      <Footer />
    </>
  );
}

const Routes: Record<string, React.ComponentType<any>> = {
  // Static routes
  "/login/callback": CallbackPage,
  "/sitemap": SiteMap,

  // Projekte
  "/projekte": ProjectsPage,
  "/projekte/personen": PersonenPage,
  "/projekte/mix-ansicht": MixAnsichtPage,
  "/projekte/lageplan": LageplanPage,
};

function CallbackPage() {
  useEffect(() => {
    // Process the login callback from the OIDC provider
    processResponse();
  }, []);

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>Processing login...</h2>
      <p>Please wait while we complete your authentication.</p>
    </div>
  );
}

// Check if the location is a project detail page
function ProjectRoutes(location: string) {
  const projectDetailMatch = location.match(/\/projekte\/([^\/]+)/);
  if (projectDetailMatch) {
    const projectId = projectDetailMatch[1];
    switch (projectId) {
      case "lageplan":
        return <LageplanPage />;
      case "personen":
        return <PersonenPage />;
      case "mix-ansicht":
        return <MixAnsichtPage />;
      default:
        return <ProjectDetailPage projectID={projectId} />;
    }
  }
}
